<app-sidenav #sidenav>
  <ng-container sidenav-header>
    <div class="sidenav-header">
      <h2 class="noselect">{{ 'management.menu.title' | translate | capitalize }}</h2>
      <mat-divider style="margin-bottom: 5px"></mat-divider>
    </div>
  </ng-container>

  <ng-container sidenav-nav>
    <app-nav-list [groups]="managementNavGroups" [groupsExpanded]="true" [afterItemClick]="closeDrawerFn">
    </app-nav-list>
  </ng-container>

  <router-outlet></router-outlet>
</app-sidenav>
